import { AddressRecord, TireQuoteItemRecordCustomer } from '@navio/nsdk';
import { BookingAddress } from 'noddi-types';
import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

interface TireOfferState {
  selectedQuoteItem: TireQuoteItemRecordCustomer | null;
  selectedAddress: BookingAddress | AddressRecord | undefined;
  setSelectedQuoteItem: (quoteItem: TireQuoteItemRecordCustomer) => void;
  setSelectedAddress: (address: BookingAddress | AddressRecord | undefined) => void;
}

const initialStateValues = {
  selectedQuoteItem: null,
  selectedAddress: undefined
};

export const useTireOfferStore = create<TireOfferState>()(
  persist(
    devtools((set) => ({
      ...initialStateValues,
      setSelectedQuoteItem: (quoteItem) => {
        const initializedQuoteItem = {
          ...quoteItem,
          quoteItemTires: quoteItem.quoteItemTires.map((tire) => ({
            ...tire,
            quantitySelected: tire.quantitySelected || tire.quantityDefault
          }))
        };
        set({ selectedQuoteItem: initializedQuoteItem });
      },
      setSelectedAddress: (address) => {
        set({ selectedAddress: address });
      }
    })),
    {
      name: 'tireOfferStore',
      storage: createJSONStorage(() => sessionStorage)
    }
  )
);
